import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const EmailVerificationSuccess = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to portfolio/dashboard after 3 seconds to reload user data
    const timer = setTimeout(() => {
      // Force a full page reload to refresh user data from the server
      window.location.href = '/portfolio';
    }, 3000);
    
    return () => clearTimeout(timer);
  }, [navigate]);
  return (
    <div className='flex items-center justify-center min-h-screen w-full bg-gray-50 p-4'>
      <div className="w-full max-w-md bg-white shadow-lg rounded-lg p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="h-8 w-8 text-green-600"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Email Verified Successfully!</h2>
          <p className="text-gray-600 mb-6">
            Your email has been successfully verified. Redirecting you to dashboard...
          </p>
          
          <div className="bg-green-50 border-l-4 border-green-400 p-4 mb-6 text-left">
            <div className="flex">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm text-green-700">
                  Your account is now active and ready to use. Please sign in to continue.
                </p>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <Link
              to="/auth/sign-in"
              className="block w-full bg-brand-500 text-white py-3 px-4 rounded-lg font-medium hover:bg-brand-600 transition-colors"
            >
              Sign In Now
            </Link>
            <Link
              to="/"
              className="block w-full bg-gray-100 text-gray-700 py-3 px-4 rounded-lg font-medium hover:bg-gray-200 transition-colors"
            >
              Go to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerificationSuccess;
